var _path, _path2, _path3, _circle, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMartiniIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.0477 112.197C87.527 115.704 92.7299 115.704 95.2092 112.197L130.319 62.5317C133.233 58.4105 130.285 52.7178 125.238 52.7178H55.0186C49.9716 52.7178 47.0244 58.4105 49.9378 62.5317L85.0477 112.197Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1289 151.491V112.389",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9512 151.49H115.32",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100.135,
    cy: 72.5,
    r: 11,
    stroke: "white",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.986 35.9331C115.501 34.3584 114.643 32.6642 113.068 32.1488C111.493 31.6335 109.799 32.4922 109.284 34.0669L114.986 35.9331ZM105.986 63.4331L114.986 35.9331L109.284 34.0669L100.284 61.5669L105.986 63.4331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMartiniIcon);
export default __webpack_public_path__ + "static/media/martini-icon.477a8bde7ae76f44b1b0cb9518ece956.svg";
export { ForwardRef as ReactComponent };